import React, { useEffect, useState } from "react"
import { motion } from 'framer-motion'
import API from "../../Common/API"
import { useDispatch, useSelector } from "react-redux"
import { Dropzone, FileMosaic } from "@files-ui/react";
import { setAlert } from "../../Store/Theme/actions"
import Button from "../../Components/Button";
import { useHistory } from "react-router-dom";

const ManageImages = ({match}) => {

    const dispatch = useDispatch()
    const [images, setImages] = useState([])
    const [loading, setLoading] = useState(true)
    const [files, setFiles] = React.useState([]);
    const [count, setCount] = useState(0)
    const [fileUrls, setFileUrls] = useState([])
    const [buttonDisable, setButtonDisable] = useState(false)
    const history = useHistory()

    useEffect(() => {
        setLoading(true)
        API.get(`/user/getImagesById/${match.params.id}`).then((imageRes) => {
            if (imageRes.status === 200) {
                setImages(imageRes.data.data.map((c) => {
                    c.removed = false
                    return c
                }))
            }
            setLoading(false)
        }).catch((err) => {
            dispatch(setAlert({ title: 'Error', subtitle: 'Something went wrong', active: true, type: 'error' }))
        })
    }, [count])

    const updateFiles = (incommingFiles) => {
        setFiles(incommingFiles);

        const newUrls = incommingFiles.map((file) => URL.createObjectURL(file.file));
        setFileUrls(newUrls);
        //even your own upload implementation
    };
    const removeFile = (id) => {
        const updatedFiles = files.filter((x) => x.id !== id);
        const removedFileIndex = files.findIndex((file) => file.id === id); //find the index of the removed file

        setFiles(updatedFiles);

        // Remove the corresponding URL
        setFileUrls((prevUrls) => {
            const newUrls = [...prevUrls];
            newUrls.splice(removedFileIndex, 1); // Remove the url at the same index
            return newUrls;
        });
    };

    const removeImage = (value) => {
        const updatedImages = images.map((c) => {
            if (c._id === value._id) {
                return { ...c, removed: !c.removed };
            }
            return c;
        });
        setImages(updatedImages);
    }

    const uploadImages = () => {
        const updatedImages = [...images, ...files]
        const formData = new FormData();
        formData.append("userId", JSON.stringify({ userId: match.params.id }))
        formData.append('existingData', JSON.stringify(images));
        updatedImages.forEach((file) => {
            formData.append('files', file.file);
        });
        API.post('/user/uploadPhoto', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((imageRes) => {
            if (imageRes.status === 200) {
                dispatch((setAlert({ title: 'Success', subtitle: "Image Uploaded Successfully", active: true, type: 'success' })))
                setCount(count + 1)
                setFiles([])
                setButtonDisable(false)
            }
        }).catch((err) => {
            setButtonDisable(false)
            dispatch((setAlert({ title: 'Error', subtitle: "Something went wrong", active: true, type: 'error' })))
        })
    }

    return (
        <>
            {
                loading ? "Loading please wait" : <motion.div className="w-full min-h-screen overlfow-hidden px-20 py-10 relative flex flex-col">
                    <motion.div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 gap-5">
                        <motion.div className="grid grid-cols-1 sm:grid-cols-1 gap-5">
                            {
                                images && images.map((c, index) => {
                                    return <motion.div key={index} className="w-full items-center grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3">
                                        {/* <img src={c.imageUrl} height={100} width={100} /> */}
                                        <img
                                            src={c.imageUrl}
                                            height={100}
                                            width={100}
                                            className={c.removed ? 'opacity-50 grayscale' : ''}
                                        />
                                        <p>{`Image ${index + 1}`}</p>
                                        <motion.div className={`bg-red-900 px-2 py-2 justify-center items-center w-full flex flex-row rounded-md text-white cursor-pointer`} onClick={() => removeImage(c)}>
                                            {c.removed ? 'Retain' : "Remove"}
                                        </motion.div>
                                    </motion.div>
                                })
                            }
                        </motion.div>
                    </motion.div>
                    {
                        images && images.length < 5 && <Dropzone className="relative my-5"
                            onChange={updateFiles}
                            value={files}
                            accept="image/*"
                            maxFiles={5 - images.filter((x) => !x.removed).length}
                        >
                            {files.map((file) => (
                                <FileMosaic preview={true} key={file.id} {...file} onDelete={removeFile} info />
                            ))}
                        </Dropzone>
                    }
                    <motion.div className="w-full justify-center items-center flex flex-row">
                        <motion.div className="flex flex-row w-96 justify-center items-center">
                            <Button type={'primary'} injectClass={'w-fit'} disabled={buttonDisable} onClick={() => !buttonDisable && uploadImages()}>Upload</Button>
                            <Button type={'danger'} injectClass={'w-fit'} onClick={() => {history.goBack()}}>Cancel</Button>
                        </motion.div>
                    </motion.div>
                </motion.div>
            }
        </>
    )
}

export default ManageImages